module.exports = __webpack_public_path__ + "img/1546043741.572830cb.jpg";